import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dumpster-rental-highland-ut")({
  beforeLoad: () => {
    throw redirect({
      href: "/services/dumpster-rental",
      statusCode: 301,
    });
  },
});
